import Swiper from 'swiper';
import { Autoplay, Pagination, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

/**
 * フェードインスライダー
 */
const fadeSlider = () => {
    const targetList = document.querySelectorAll('.js_fadeSlider');
    if (!targetList.length) return;

    for (const target of targetList) {
        const swiper = new Swiper(target, {
            init: false, //ページ読み込み時に初期化しない
            modules: [Autoplay, Pagination, EffectFade],
            effect: 'fade',
            speed: 1000,
            loop: true,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });

        // スライダーが画面に入ったら初期化
        const doWhenIntersect = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !swiper.initialized) {
                    swiper.init();
                }
            });
        }
        const observer = new IntersectionObserver(doWhenIntersect);
        observer.observe(target);
    }
}

export default fadeSlider;
